import { ONLINE_MERCHANT_CARD_CONFIG } from "../Sections/OnlineMerchantManagementMdrSection";

const handleStringField = (value) => {
  // coerce null to empty string (for form check difference consistency)
  // should be applied to all fields that are inputText or selection (single)
  return value || "";
}
const handleBufferTypeFormat = (value) => !!value?.data?.[0]

export const parseMerchantEntityPayload = (payload) => {

  const formData = {
    merchantId: payload.merchant_id,
    status: payload.status,
    updateTime: payload.update_time,
    lockAccountType: handleStringField(payload.lock_account_type),
    remark: handleStringField(payload.remark),
    terminateTime: payload.terminate_time,

    displayName: handleStringField(payload.display_name),
    name: handleStringField(payload.name),
    countryOrRegion: handleStringField(payload.country_or_region),
    legalName: handleStringField(payload.legal_name),
    businessRegistration: handleStringField(payload.br),
    businessEstablishedDate: payload.business_established_date,
    address: handleStringField(payload.address),
    addressSecondaryLang: handleStringField(payload.address_secondary_lang),
    city: handleStringField(payload.city),
    stateOrProvince: handleStringField(payload.state_or_province),
    contactPerson: handleStringField(payload.contact_person),
    email: handleStringField(payload.email),
    phone: handleStringField(payload.phone),
    mcc: handleStringField(payload.mcc),
    base64EncodedImg: payload.logo_url,
    homepage_url: handleStringField(payload.homepage_url),
    theme_color: handleStringField(payload.theme_color),
    count_down: payload.count_down,
    callback_countdown: payload.callback_countdown,
    base64EncodedTermsPdf: payload?.terms_url ? [
      {
        type: "httpLink",
        content: payload?.terms_url
      }
    ] : [],
    isBoxsPayMerchant: handleBufferTypeFormat(payload["is_boxs_pay_merchant"]),

    currencyList: payload.currency_list?.split(",") || [],
    shareholderInfo: JSON.parse(payload.shareholder_info || "[]").map((info) => ({
      ...info,
      percentage: parseFloat(info.percentage),
    })),
    currencyTxnLimitList: Object.entries(JSON.parse(payload.currency_txn_limit_list || "{}")).map(([currency, limit]) => ({ currency, amountLimit: limit })) || [],

    cardEnable: handleBufferTypeFormat(payload["card_enable"]),
    alihkEnable: handleBufferTypeFormat(payload["alihk_enable"]),
    alicnEnable: handleBufferTypeFormat(payload["alicn_enable"]),
    wechatEnable: handleBufferTypeFormat(payload["wechat_enable"]),
    applePayEnable: handleBufferTypeFormat(payload["apple_pay_enable"]),
    googlePayEnable: handleBufferTypeFormat(payload["google_pay_enable"]),
    upiEnable: payload.upiEnable,

    wechatSubAppId: handleStringField(payload.wechat_sub_appid),
    wechatSubMerchantId: handleStringField(payload.wechat_sub_mchid),
    tokenPoolMid: handleStringField(payload.token_pool_mid),
  }

  return formData;
}

export const parseMerchantMdrPayload = (payload) => {
  const handleNumberToPercantage = (pn) => {
    // multiple mdr by 100 since it will be displayed as a percentage
    // prevent floating point error
    if (typeof pn === "number") return Math.round(((pn || 0) * 100) * 1e10) / 1e10
    else return pn
  }

  const merchantCurrenctListUsdEntry = payload.merchantCurrencyList?.find((item) => item.currencyCode === "USD");
  const merchantSettleCurrencyListUsdEntry = payload.merchantSettleCurrencyList?.find((item) => item.settleCurrencyCode === "USD");
  const mdrList = Object.fromEntries(Object.entries(ONLINE_MERCHANT_CARD_CONFIG).map(([cardType, config]) => {
    const record = payload.mdrList?.find((item) => item.cardType === cardType);

    return [
      cardType,
      {
        ...record?.id && { id: record.id },
        mdr: handleNumberToPercantage(record?.mdr) || config.defaultValues.mdr,
        foreignMdr: handleNumberToPercantage(record?.foreignMdr) || config.defaultValues.foreignMdr,
        salesCommission: handleNumberToPercantage(record?.salesCommission) || config.defaultValues.salesCommission,
        referrerCommission: handleNumberToPercantage(record?.referrerCommission) || config.defaultValues.referrerCommission,
        remark: record?.remark || config.defaultValues.remark,
      }
    ]
  }))

  const formData = {
    zeroPlan: !!payload.zeroPlan,
    sales: handleStringField(payload?.sales?.id),
    referrer: handleStringField(payload?.referrer?.id),
    bankAccount: handleStringField(payload.bankAccount),
    beneficiary: handleStringField(payload.beneficiary),

    gatewayFee: payload.gatewayFee,
    tokenFee: payload.tokenFee,
    threeDSFee: payload.threeDSFee,
    settleCycle: payload.settleCycle,
    customSettle: payload.customSettle,

    usdSettleCurrency: merchantCurrenctListUsdEntry?.settleCurrencyCode || "HKD",
    usdBankAccount: handleStringField(merchantSettleCurrencyListUsdEntry?.bankAccount),
    usdBeneficiary: handleStringField(merchantSettleCurrencyListUsdEntry?.beneficiary),
    usdGatewayFee: merchantSettleCurrencyListUsdEntry?.gatewayFee || null,
    usdTokenFee: merchantSettleCurrencyListUsdEntry?.tokenFee || null,
    usdThreeDSFee: merchantSettleCurrencyListUsdEntry?.threeDSFee || null,
    mdrList: mdrList,

    updated: payload.updated,
  }
  return formData;
}

export const parseMerchantNuveiConfigPayload = (payload) => {
  const formData = {
    siteId: handleStringField(payload?.siteId),
  }
  return formData;
}

export const parseEmployeeDetailPayload = (payload) => {
  const formData = {
    employeeId: payload.id,
    status: payload.status,
    updateTime: payload.update_date,
    lockAccountType: payload.lock_account_type,
    remark: payload.remark,
    terminatedDate: payload.terminated_date,

    merchantId: payload.merchant_id,
    name: payload.firstname,
    email: payload.email,
    permission: payload.permission?.split(",") || [],
    isBoxsPay: handleBufferTypeFormat(payload.is_boxs_pay),
  }
  return formData;
}